import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { usePopper } from 'react-popper';
import DropdownSelect from './DropdownSelect';
import OptionsList from './OptionsList';
import { useDropDown } from './useDropDown';
import InputContainer from '../InputContainer';
import { minimumWidth } from './utils';
import { dropDownContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Dropdown = function Dropdown(props) {
  var required = props.required,
      validate = props.validate,
      hasErrorProp = props.hasError,
      offset = props.offset,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'auto' : _props$placement;
  var hookProperties = useDropDown(props);
  var handleToggle = hookProperties.handleToggle,
      handleKeyDown = hookProperties.handleKeyDown,
      handleBlur = hookProperties.handleBlur,
      error = hookProperties.error,
      isTouched = hookProperties.isTouched,
      selectRef = hookProperties.selectRef,
      setSelectRef = hookProperties.setSelectRef,
      optionsListRef = hookProperties.optionsListRef;

  var _usePopper = usePopper(selectRef, optionsListRef, {
    modifiers: [minimumWidth, {
      name: 'flip',
      options: {
        allowedAutoPlacements: ['bottom', 'top'],
        rootBoundary: window
      }
    }, {
      name: 'offset',
      options: {
        offset: offset !== null && offset !== void 0 ? offset : [0, 0]
      }
    }].filter(Boolean),
    placement: placement
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var hasError = isTouched && !!error;
  var hasValidation = _isFunction(validate) || required;
  return ___EmotionJSX(InputContainer, _extends({}, props, {
    error: error,
    isTouched: isTouched
  }), ___EmotionJSX("div", {
    ref: setSelectRef,
    role: "listbox",
    tabIndex: 0,
    onBlur: handleBlur,
    onClick: handleToggle,
    onKeyDown: handleKeyDown,
    css: dropDownContainer(hasValidation, props)
  }, ___EmotionJSX(DropdownSelect, _extends({}, props, hookProperties, {
    hasError: hasError || hasErrorProp
  })), ___EmotionJSX(OptionsList, _extends({}, props, hookProperties, {
    popperStyle: styles.popper,
    popperAttributes: attributes.popper
  }))));
};

Dropdown.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  validate: PropTypes.func,
  horizontal: PropTypes.bool,
  multiSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.array]),
  options: PropTypes.array,
  small: PropTypes.bool,
  onTop: PropTypes.bool,
  onLeft: PropTypes.bool,
  noClear: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  withSearch: PropTypes.bool,
  noSimplify: PropTypes.bool,
  displayKey: PropTypes.string,
  uniqueKey: PropTypes.string,
  hasError: PropTypes.bool,
  offset: PropTypes.array,
  placement: PropTypes.string,
  strategy: PropTypes.string
};
var DropdownRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(Dropdown, _extends({}, props, {
    dropdownRef: ref
  }));
});
DropdownRef.displayName = 'Dropdown';
export default DropdownRef;